import format from 'date-fns/format';

import { ProformaInvoiceFormGroupByMode } from '../../../../../teams/components/forms/ProformaInvoiceForm/ProformaInvoiceForm.types';

import { InvoiceItemsViewItem } from '../../hooks/useInvoiceItemsViewContext';

interface GetInvoiceItemsViewGroupKeyOptions {
  item: InvoiceItemsViewItem;
  enableGrouping: boolean;
  groupBy: ProformaInvoiceFormGroupByMode;
}

function getInvoiceItemsViewGroupKey({
  item,
  enableGrouping,
  groupBy
}: GetInvoiceItemsViewGroupKeyOptions) {
  if (!enableGrouping) {
    return '';
  }

  switch (groupBy) {
    case ProformaInvoiceFormGroupByMode.PROJECT_TASK:
    case ProformaInvoiceFormGroupByMode.TASK:
      return item.taskNanoId;

    case ProformaInvoiceFormGroupByMode.PROJECT:
      return 'rootProjectNanoId' in item
        ? item?.rootProjectNanoId
        : item.projectNanoId;

    case ProformaInvoiceFormGroupByMode.MONTH_INVOICE_CREATED:
      return item.invoiceCreationMonth;

    case ProformaInvoiceFormGroupByMode.MONTH_TASK_CREATED:
      return format(new Date(item.taskCreatedAt), 'yyyy-MM');

    case ProformaInvoiceFormGroupByMode.MONTH_TASK_DUE_DATE:
      return item.taskDueDateMonth;

    case ProformaInvoiceFormGroupByMode.PROJECT_GROUP:
      return item.projectNanoId;

    case ProformaInvoiceFormGroupByMode.PROJECT_GROUP_TASK:
      return `${item.projectNanoId}-${item.taskNanoId}`;

    case ProformaInvoiceFormGroupByMode.GROUP_TASK:
      return item.taskNanoId;

    case ProformaInvoiceFormGroupByMode.MONTH_TASK_DONE:
      return item.taskDoneMonth;

    case ProformaInvoiceFormGroupByMode.MONTH_PROJECT_CREATED:
      return format(new Date(item.projectCreatedAt), 'yyyy-MM');

    case ProformaInvoiceFormGroupByMode.MONTH_PROJECT_CLOSED:
      return item.projectClosureMonth;

    case ProformaInvoiceFormGroupByMode.INVOICE_TAG:
      return item.items[0].invoices?.[0]?.invoiceTag;

    default:
      return '';
  }
}

export default getInvoiceItemsViewGroupKey;
